import { AutogenModelUnpostedWireOrderLookup, AutogenRowUnpostedWireOrderLookup } from "./autogen/AutogenModelUnpostedWireOrderLookup";

export class ModelUnpostedWireOrderLookup extends AutogenModelUnpostedWireOrderLookup<RowUnpostedWireOrderLookup> {
	constructor() {
		super(RowUnpostedWireOrderLookup);
	}
}

export class RowUnpostedWireOrderLookup extends AutogenRowUnpostedWireOrderLookup {
}